import baseUrl from '@/api/base-url';
import utilities from '@/Utilities/common';
import request from '@/Utilities/httpRequest';

export default {

    setBaseUrl (url) {
        baseUrl.setBaseUrl(url);
    },

    getUrl (controllerAction) {
        return baseUrl.getUrl(controllerAction);
    },

    async addToCart (sku, quantity, type) {
        const params = {
            sku: sku,
            qty: quantity,
            type: type,
            vueMode : false,
            oti: utilities.getMubOtiData(),
        };
        return await request.post(this.getUrl('cart/add'), params, false);
    },

    async addToCartBulk (items, validate) {
        const data = {
            items: items,
            validate: validate,
            oti: utilities.getMubOtiData(true),            
        };
        return await request.post(this.getUrl('cart/update-bulk'), data, false);
    },

    async updateItem(itemId, qty = 1, validate, vueMode = false, isMiniCart = false) {
        const params = {
            lin: itemId,
            qty: qty,
            validate: validate ? 1 : 0,
            vueMode: vueMode,
            isMiniCart: isMiniCart ? 1 : 0
        };
        return await request.get(this.getUrl('cart/update'), params, false);
    },

    async removeItem(itemId, validate, vueMode = false, isMiniCart = false) {
        const params = {
            lin: itemId,
            validate: validate ? 1 : 0,
            vueMode: vueMode,
            isMiniCart: isMiniCart ? 1 : 0
        };
        return await request.get(this.getUrl('cart/remove'), params, false);
    }
    // async addToCartBulk (items) {
    //     /*if(items) { // addComboToCart method has more verifications
    //         items.forEach((element) => {
    //            this.addToCart(element.sku, element.qty, element.type);
    //         });
    //         return 1;
    //     } else {
    //         return 0;
    //     }*/

    //     let generatedResponse = [];
    //     await Promise.all(items.map((element) => {
    //         try {
    //             // here candidate data is inserted into  
    //             let insertResponse = this.addToCart(element.sku, element.qty, element.type);
    //             // and response need to be added into final response array 
    //             generatedResponse.push(insertResponse);
    //         } catch (error) {
    //             console.log('error'+ error);
    //         }
    //     }));
    //     //console.log('complete all'); // gets logged first
    //     return generatedResponse; // return without waiting for process of 
        
    // }

};
